export default {
  homeRow1: 'ACCELERATE ',
  homeRow2: 'YOUR',
  homeRow3: 'DIGITAL TRANSFORMATION',
  homeRow4: 'Connect Your Value Chain',
  homeRow5: 'Enrich Your Customer Experience',
  homeRow6: 'Make Faster, Better Decisions',
  homeRow7: 'JWI is the only local vendor ',
  homeRow8: 'with decades of industry experience',
  homeRow9: 'software expertise and proven capabilities to help China-based',
  homeRow10: 'companies eliminate their dependency on foreign vendors.',
  homeRow11: 'A cloud-native platform',
  homeRow12: 'that lets you, not your PLM vendor, decide your digital transformation priorities.',
  homeRow13: 'Run new applications concurrently with your existing systems,',
  homeRow14: 'and replace your current software at a pace that makes sense for your business.',
  homeRow15: 'LEARN MORE',
  homeRow16: 'SUBMIT',
  homeRow17: 'READY TO ACCELERATE',
  homeRow18: 'DIGITAL TRANSFORMATION?',
  homeRow19: "If you're ready to add new digital applications to your",
  homeRow20: 'product development process, or want to run a structured proof of concept,',
  homeRow21: 'please schedule a call with a JWI solutions expert.',
  homeRow22: 'I’D LIKE TO *',
  homeRow23: 'NAME *',
  homeRow24: 'EMAIL *',
  homeRow25: 'COMPANY',
  homeRow26: 'GET IN TOUCH',
  homeRow27: 'JOB TITLE',
  homeRow28: 'MESSAGE/QUESTION',
  homeRow29: 'is required field.',
  homeRow30: 'JOIN JWI COMMUNITY ON'
}
